import { useQuery } from '@tanstack/react-query';
import { useAuthStore } from '../store/auth.store.js';
import { useClientStore } from '../store/client.store.js';
import { getOrders, getOrdersArchive } from '../api/orders.js';

function buildParams(filters, user, selectedClientId) {
  const { paymentStatusDetail, ...rest } = filters;
  const params = { ...rest };
  if (paymentStatusDetail) params.paymentStatusDetail = paymentStatusDetail;
  if (user?.role === 'superadmin' && selectedClientId) params.clientId = selectedClientId;
  return params;
}

export function useOrders(filters = {}) {
  const user = useAuthStore((s) => s.user);
  const { selectedClientId } = useClientStore();
  const params = buildParams(filters, user, selectedClientId);

  return useQuery({
    queryKey: ['orders', params],
    queryFn:  () => getOrders(params),
    staleTime: 15_000,
    enabled: user?.role !== 'superadmin' || !!selectedClientId,
  });
}

export function useOrdersArchive(filters = {}) {
  const user = useAuthStore((s) => s.user);
  const { selectedClientId } = useClientStore();
  const params = buildParams(filters, user, selectedClientId);

  return useQuery({
    queryKey: ['orders-archive', params],
    queryFn:  () => getOrdersArchive(params),
    staleTime: 30_000,
    enabled: user?.role !== 'superadmin' || !!selectedClientId,
  });
}
